import React from "react";
import { observer } from "mobx-react-lite";
import { Navigate } from "react-router-dom";
import { useStore } from "~/hooks/useStore";
import RootStore from "~/store/RootStore";
import ROUTES from "~/utils/routes";

interface Props {
  children?: React.ReactNode;
}

const RouterAuthorized: React.FC<Props> = observer(({ children }) => {
  const store: RootStore = useStore();
  const newPatient = Boolean(store.patientStore.currentPatient);

  return <>{newPatient ? children : <Navigate to={ROUTES.LOGIN.PATHNAME} />}</>;
});

export default RouterAuthorized;
